export const ROUTE_HOME = '/';
export const ROUTE_ABOUT = '/hakkimizda';
export const ROUTE_TENNIS_GUIDE = '/tenis';
export const ROUTE_NEWS = '/haberler';
export const ROUTE_LEAGUES = '/ligler';
export const ROUTE_DOUBLES_LEAGUES = '/cift-ligler';
export const ROUTE_BUSINESS_LEAGUES = '/business-ligler';
export const ROUTE_LOGIN = '/uyelik/giris';
export const ROUTE_LOGIN_STEP_1 = '/uyelik/uye-ol?step=1';
export const ROUTE_LOGIN_STEP_2 = '/uyelik/uye-ol?step=2';
export const ROUTE_REGISTER = '/uyelik/uye-ol';
export const ROUTE_PRIVACY_POLICY = '/gizlilik';
export const ROUTE_PRICING = '/ucretlendirme';
export const ROUTE_CONTACT = '/iletisim';
export const ROUTE_CONTACT_FORM = '/iletisim-formu';
export const ROUTE_EXPLORE = '/kesfet';
export const ROUTE_CLUBS = '/kulupler';
export const ROUTE_COURTS = '/kortlar';
export const ROUTE_MY_LEAGUE = '/ligim';
export const ROUTE_PRIZES = '/oduller';
export const ROUTE_PLAY = '/oyna';
export const ROUTE_PLAY_MY_OFFERS_TAB = '/oyna?tab=yapilan-teklifler';
export const ROUTE_PLAY_MY_MATCHES_TAB = '/oyna?tab=maclarim';
export const ROUTE_MY_PROFILE = '/profilim';
// LG-68 "Tenis Yılın" kişisel yıl özeti (yalnız sahibine; dizine girmez).
export const ROUTE_YEAR_REVIEW = '/yilin-ozeti';
export const ROUTE_TOURNAMENTS = '/turnuvalar';
export const ROUTE_HELP = '/yardim';
export const ROUTE_RULES = '/akademi/kurallar';
export const ROUTE_MATCH_PLAYING_PROCESS = '/akademi/mac-oynama-sureci';
export const ROUTE_HOW_DO_I_JOIN = '/akademi/nasil-uye-olurum';
export const ROUTE_FAQ = '/sss';
export const ROUTE_NOT_FOUND = '/404';
export const ROUTE_MY_APPLICATIONS = '/basvurularim';
export const ROUTE_OPENING_REQUEST = '/lig-ac';
export const ROUTE_ADMIN_DOUBLES_APPLICATIONS = '/yonetim/cift-basvurular';

// Tek noktadan değiştirilebilir admin yetki eşiği.
// Kullanici.yetki >= MIN_ADMIN_YETKI olan kullanıcılar yönetim sayfalarını görebilir.
export const MIN_ADMIN_YETKI = 1;
